import React, { useCallback } from 'react';
import { getIn } from 'formik';

import { Select } from '../../select';
import { FieldElementPropTypes } from '../propTypes';
import { buildTooltipAdornment } from './tooltip-adornment';

const SelectField = ({
  field: { id, name, label, mode, options, value, optional, onChange, tooltipText, tooltipLabel, InputProps, ...props },
  ctx: { setFieldValue, touched, errors, classes, setFieldTouched, values }
}) => {
  const handleChange = useCallback(
    (fieldName, fieldValue) => {
      setFieldValue(fieldName, fieldValue);
      setFieldTouched(name, true, false);
      if (onChange) {
        onChange(fieldValue, fieldName);
      }
    },
    [setFieldValue, setFieldTouched, id, onChange]
  );
  const tooltipAdornment = buildTooltipAdornment(tooltipText, tooltipLabel);
  return (
    <Select
      key={name}
      id={name}
      name={name || id}
      label={label}
      onChange={handleChange}
      value={getIn(values, name) || value}
      error={getIn(touched, name || id) && !!getIn(errors, name || id)}
      helperText={getIn(touched, name || id) && getIn(errors, name || id)}
      options={options}
      mode={mode}
      fullWidth
      classes={classes[id]}
      {...props}
      InputProps={{
        ...(tooltipAdornment ? { endAdornment: tooltipAdornment } : {}),
        ...(InputProps || {})
      }}
    />
  );
};

SelectField.propTypes = FieldElementPropTypes;

export default SelectField;
